/**
 * PhotoItem2 templates registry
 *
 * Exports all available templates and the template registry for type-safe selection.
 *
 * @module PhotoItem2/templates
 */

import { PhotoOnlyTemplate } from './PhotoOnlyTemplate';
import { FullDetailsTemplate } from './FullDetailsTemplate';
import { ClassicFeedTemplate } from './ClassicFeedTemplate';
import { SxSFeedTemplate } from './SxSFeedTemplate';
import { CollectionEditTemplate } from './CollectionEditTemplate';
import { CollectionViewTemplate } from './CollectionViewTemplate';
import { CollectionViewExifTemplate } from './CollectionViewExifTemplate';
import { LightroomListTemplate } from './LightroomListTemplate';
import type { PhotoItem2TemplateComponent } from '../PhotoItem2.types';

/**
 * Template registry mapping names to components
 *
 * To add a new template:
 * 1. Create template component implementing PhotoItem2TemplateProps
 * 2. Import it above
 * 3. Add to this registry
 * 4. TypeScript will automatically include in TemplateName union
 */
export const templates: Record<string, PhotoItem2TemplateComponent> = {
  'photo-only': PhotoOnlyTemplate,
  'full-details': FullDetailsTemplate,
  'classic-feed': ClassicFeedTemplate,
  'sxs-feed': SxSFeedTemplate,
  'collection-edit': CollectionEditTemplate,
  'collection-view': CollectionViewTemplate,
  'collection-view-exif': CollectionViewExifTemplate,
  'lightroom-list': LightroomListTemplate,
};

/**
 * Extract template names as literal union type
 * Enables TypeScript autocomplete and validation
 */
export type TemplateName = keyof typeof templates;

// Re-export templates for direct import
export { PhotoOnlyTemplate, FullDetailsTemplate, ClassicFeedTemplate, SxSFeedTemplate, CollectionEditTemplate, CollectionViewTemplate, CollectionViewExifTemplate, LightroomListTemplate };
